export { default as ModalContainer } from './modal-container.vue';
